module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "level-right"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "id": "loginBtn"
    },
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = true
      }
    }
  }, [_vm._v("Client Login")]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium is-hidden",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": "/admin",
      "id": "clientPortalBtn"
    }
  }, [_vm._v("Client Portal")]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium is-hidden",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": "/",
      "id": "homeBtn"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-medium is-hidden",
    attrs: {
      "id": "logoutBtn"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('modal-form', _vm._b({}, 'modal-form', _vm.formProps, false))], 1)], 1), _vm._v(" "), _c('main', [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-898c689e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 520
// module chunks = 1